import React from "react";

import { ChevronRight, LifeBuoy } from "lucide-react";
import { useTranslation } from "react-i18next";

const HelpEntryCard = ({ onClick }) => {
  const { t } = useTranslation(["walletOffer"]);

  return (
    <button
      type="button"
      onClick={onClick}
      aria-haspopup="dialog"
      className="group flex w-full items-center gap-3 rounded-2xl border border-gray-200 bg-white p-[1rem] text-left shadow-sm transition-all hover:shadow-md active:scale-[0.99] focus:outline-none focus-visible:ring-2 focus-visible:ring-cfPrimary focus-visible:ring-offset-2"
    >
      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-cfTableHeaderBackgroundColor text-cfPrimary">
        <LifeBuoy className="h-5 w-5" aria-hidden="true" />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-semibold text-cfHeadingText">
          {t("walletOffer:help_entry_title")}
        </span>
        <span className="mt-0.5 block text-xs text-gray-500">
          {t("walletOffer:help_entry_description")}
        </span>
      </span>
      <ChevronRight
        className="h-5 w-5 shrink-0 text-gray-400 transition-transform group-hover:translate-x-0.5 group-hover:text-cfPrimary"
        aria-hidden="true"
      />
    </button>
  );
};

export default HelpEntryCard;
